import { useState } from 'react';
import Button from '../../../UI/Button';

const ClientApplicationChecklist = ({
  clientApplicationChecklist,
  children,
}: {
  clientApplicationChecklist?: string[];
  children: React.ReactNode;
}) => {
  const [isApplicationStarted, setIsApplicationStarted] = useState(false);

  const standardApplicationChecklist = [
    'Business and Personal tax returns',
    'Personal Financial Statement',
    'Company Legal Name',
    'Company EIN',
    'Prior Project Details',
  ];

  let applicationChecklist: string[] = [...standardApplicationChecklist];
  if (clientApplicationChecklist) {
    applicationChecklist = [...standardApplicationChecklist, ...clientApplicationChecklist];
  }

  const onStartApplicationHandler = () => {
    setIsApplicationStarted(true);
  };

  if (isApplicationStarted) {
    return children;
  }

  return (
    <div className='containter mx-auto bg-white rounded-md py-4'>
      <div className=''>
        <h2 className='mt-0 text-primaryColor-normal border-l-4 border-green-500 px-6 py-2'>Application Checklist</h2>
      </div>
      <section className='px-6'>
        <p>Please have the following information ready in order to complete the application.</p>
        <ul className='my-5 space-y-2'>
          {applicationChecklist.map((item) => (
            <li key={item} className='flex gap-2 items-center'>
              <span className='h-2 w-2 bg-primaryColor-normal rounded-full' /> {item}
            </li>
          ))}
        </ul>
        <div className='flex justify-end'>
          <Button label='Start Application' btnStyle='btn-primary' btnType='button' onClick={onStartApplicationHandler} />
        </div>
      </section>
    </div>
  );
};

export default ClientApplicationChecklist;
